// extracted by mini-css-extract-plugin
export default {"wrapper":"XfaTemplateContainer_wrapper__0SK4z","rootWrapper":"XfaTemplateContainer_rootWrapper__W0R0c"};